import React from "react";
import { Form, ListGroup } from "react-bootstrap";
const MultiUpload = (props) => {
  return (
    <div className={`${props.className}`}>
      <Form.Control
        required={props.required}
        id={props.id}
        onChange={props.onChange}
        type="file"
        accept={props.accept}
        key={props.uploadKey}
        title="Odaberi datoteku"
        multiple={true}
        style={{ display: "none" }}
      />
      <label
        style={{
          borderColor: props.style,
          cursor: "pointer",
          width: "100%",
          borderRadius: "5px",
          border: "1px solid #ced4da",
          color: "#4a5057ff",
          display: "inline-block",
        }}
        htmlFor={props.id}
      >
        {(props.selectedFiles.length === 0 && (
          <span
            className="d-inline-block text-truncate w-75"
            style={{ fontWeight: "400", marginTop: "5px", marginLeft: "10px" }}
          >
            Odaberite datoteku...
          </span>
        )) || (
          <span
            className="d-inline-block text-truncate w-75"
            style={{ fontWeight: "400", marginTop: "5px", marginLeft: "10px" }}
          >
            Datoteke odabrane
          </span>
        )}
        <div
          style={{
            float: "right",
            backgroundColor: "#e9ecefff",
            flexDirection: "row",
            padding: "8px",
            fontWeight: "400",
          }}
        >
          <span>Učitaj</span>
        </div>
      </label>
      {(props.selectedFiles.length > 0 && (
        <ListGroup key={`lista-privitaka`}>
          {props.selectedFiles.map((element) => {
            return (
              <ListGroup.Item key={element.id} variant="secondary">
                {element.file.name}
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      )) ||
        ""}
    </div>
  );
};

export default MultiUpload;
